import { AlertTriangle } from "lucide-react";
import { useLocation } from "wouter";
import { Button } from "../components/ui/button";
import React from "react";


export default function NotFound() {
  const [, setLocation] = useLocation();
  
  return (
    <div className="flex flex-col  w-full bg-black text-white">
      
      {/* Main Error Content */}
      <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
        <div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center mb-6">
          <AlertTriangle className="w-10 h-10 text-red-500" />
        </div>
        
        <h1 className="text-3xl font-bold mb-2">404</h1>
        <div className="crash-dialog">
        <pre>
            <div>FATAL EXCEPTION: main</div>
            <div>Process: com.ranjan.fyi.notfound, PID: 404</div>
            <div>java.io.FileNotFoundException: Page not found</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;at com.ranjan.core.Navigator.navigate(Navigator.java:101)</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;at com.ranjan.ui.HomeScreen.onIntentReceived(HomeScreen.java:47)</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;at android.app.Activity.performCreate(Activity.java:8000)</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;at android.app.Instrumentation.callActivityOnCreate(Instrumentation.java:1309)</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;at android.app.ActivityThread.performLaunchActivity(ActivityThread.java:3422)</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;at android.app.ActivityThread.handleLaunchActivity(ActivityThread.java:3595)</div>
            <div>Caused by: com.ranjan.errors.RouteNotDefinedException: /this-page-does-not-exist</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;at com.ranjan.routing.Router.resolve(Router.java:88)</div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;... 6 more</div>
            <div></div>
            <div>---</div>
            <div>Oops! The page you requested doesn’t exist.</div>
            <div>Please check the URL or return to the home screen.</div>
          </pre>
        </div>
            
        <Button 
          onClick={() => setLocation("/")}
          className="px-6 bg-blue-600 hover:bg-blue-700"
        >
          Return to Home Screen
        </Button>
      </div>
      
    </div>
  );
}
